import { render, staticRenderFns } from "./WizardPage.vue?vue&type=template&id=2579ba7c&scoped=true&"
import script from "./WizardPage.vue?vue&type=script&lang=js&"
export * from "./WizardPage.vue?vue&type=script&lang=js&"
import style0 from "./wizard-page.scss?vue&type=style&index=0&id=2579ba7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2579ba7c",
  null
  
)

export default component.exports